import {CreateTeam, RoleId, TeamId, UserId} from "platformed-client/types";
import {invalidateQueries, q} from "../state";
import {platformedClient} from ".";

export async function create(team: CreateTeam) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/teams", {path: {}, body: team});
  await invalidateQueries([q.teams.filter(), q.userTeams.filter()]);
  return res;
}

export async function get(teamId: TeamId) {
  return await platformedClient.internalRequest("get", "/region/{region}/api/teams/{team_id}", {
    path: {team_id: teamId},
  });
}

export async function updateName(teamId: TeamId, name: string) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/teams/{team_id}/name", {
    path: {team_id: teamId},
    body: name,
  });
  await invalidateQueries([
    q.teams.filter(),
    q.teamMembers.filter(teamId),
    q.userTeams.filter(),
    q.accountUsers.filter(),
    q.owner.filter(),
    q.resolvedOwner.filter(),
  ]);
  return res;
}

export async function updateDescription(teamId: TeamId, description: string) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/teams/{team_id}/description", {
    path: {team_id: teamId},
    body: description,
  });
  await invalidateQueries([
    q.teams.filter(),
    q.teamMembers.filter(teamId),
    q.userTeams.filter(),
    q.accountUsers.filter(),
    q.owner.filter(),
    q.resolvedOwner.filter(),
  ]);
  return res;
}

export async function delete_(teamId: TeamId) {
  const res = await platformedClient.internalRequest("delete", "/region/{region}/api/teams/{team_id}", {
    path: {team_id: teamId},
  });
  await invalidateQueries([
    q.teams.filter(),
    q.deletedTeams.filter(),
    q.userTeams.filter(),
    q.teamMembers.filter(teamId),
    q.accountUsers.filter(),
    q.owner.filter(),
    q.resolvedOwner.filter(),
    q.whoAmIOnAccount.filter(),
  ]);
  return res;
}

export async function restore(teamId: TeamId) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/teams/{team_id}/restore", {
    path: {team_id: teamId},
  });
  await invalidateQueries([
    q.teams.filter(),
    q.deletedTeams.filter(),
    q.userTeams.filter(),
    q.teamMembers.filter(teamId),
    q.accountUsers.filter(),
    q.owner.filter(),
    q.resolvedOwner.filter(),
    q.whoAmIOnAccount.filter(),
  ]);
  return res;
}

export async function list() {
  return await platformedClient.internalRequest("get", "/region/{region}/api/teams", {path: {}});
}

export async function listDeleted() {
  const deleted = true;
  return await platformedClient.internalRequest("get", "/region/{region}/api/teams", {path: {}, query: {deleted}});
}

export async function listMembers(teamId: TeamId) {
  return await platformedClient.internalRequest("get", "/region/{region}/api/teams/{team_id}/members", {
    path: {team_id: teamId},
  });
}

export async function listPermissions(teamId: TeamId) {
  return await platformedClient.internalRequest("get", "/region/{region}/api/teams/{team_id}/permissions", {
    path: {team_id: teamId},
  });
}

export async function addMember(teamId: TeamId, userId: UserId) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/teams/{team_id}/members", {
    path: {team_id: teamId},
    body: userId,
  });
  await invalidateQueries([
    q.teams.filter(),
    q.userTeams.filter(userId),
    q.teamMembers.filter(teamId),
    q.accountUsers.filter(),
    q.whoAmIOnAccount.filter(),
  ]);
  return res;
}

export async function removeMember(teamId: TeamId, userId: UserId) {
  const res = await platformedClient.internalRequest(
    "delete",
    "/region/{region}/api/teams/{team_id}/members/{user_id}",
    {path: {team_id: teamId, user_id: userId}},
  );
  await invalidateQueries([
    q.teams.filter(),
    q.userTeams.filter(userId),
    q.teamMembers.filter(teamId),
    q.accountUsers.filter(),
    q.whoAmIOnAccount.filter(),
  ]);
  return res;
}

export async function addPermission(teamId: TeamId, permissionId: RoleId) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/teams/{team_id}/permissions", {
    path: {team_id: teamId},
    body: permissionId,
  });
  await invalidateQueries([
    q.teams.filter(),
    q.teamPermissions.filter(teamId),
    q.teamMembers.filter(teamId),
    q.accountUsers.filter(),
    q.owners.filter(),
    q.whoAmIOnAccount.filter(),
  ]);
  return res;
}

export async function removePermission(teamId: TeamId, permissionId: RoleId) {
  const res = await platformedClient.internalRequest(
    "delete",
    "/region/{region}/api/teams/{team_id}/permissions/{permission_id}",
    {path: {team_id: teamId, permission_id: permissionId}},
  );
  await invalidateQueries([
    q.teams.filter(),
    q.teamPermissions.filter(teamId),
    q.teamMembers.filter(teamId),
    q.accountUsers.filter(),
    q.owners.filter(),
    q.whoAmIOnAccount.filter(),
  ]);
  return res;
}
